import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A hash means the target page owns the scroll position: its anchor only exists
    // once the CMS data has rendered, so forcing the top here would fight it.
    if (hash) return;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

